/** Payload / UI field keys for Reserve → Activities (aligned with sample payload & tooltips). */

export const RESERVE_ACTIVITIES_FIELD_ACTIVITY_CODE = "Activity Code";
export const RESERVE_ACTIVITIES_FIELD_ACTIVITY_NAME = "Activity Name";
export const RESERVE_ACTIVITIES_FIELD_ACTIVITY_TYPE = "Activity Type";
export const RESERVE_ACTIVITIES_FIELD_CLASS_TYPE = "Class Type";
export const RESERVE_ACTIVITIES_FIELD_ACTIVITY_DESCRIPTION =
  "Activity Description";

/** Activity Type dropdown values (Reserve Activities). */
export const RESERVE_ACTIVITIES_ACTIVITY_TYPE_OPTIONS = [
  "Group lesson",
  "Private lesson",
  "Open booking",
] as const;

/** Class Type dropdown values (Reserve Activities). */
export const RESERVE_ACTIVITIES_CLASS_TYPE_OPTIONS = [
  "By session",
  "By class",
  "By duration",
] as const;
export const RESERVE_ACTIVITIES_FIELD_ACTIVITY_CATEGORY = "Activity Category";
export const RESERVE_ACTIVITIES_FIELD_ACTIVITY_SUB_CATEGORY =
  "Activity Sub-Category";
export const RESERVE_ACTIVITIES_FIELD_MIN_GROUP_SIZE = "Min Group Size";
export const RESERVE_ACTIVITIES_FIELD_MAX_GROUP_SIZE = "Max Group Size";
export const RESERVE_ACTIVITIES_FIELD_MIN_ACTIVITY_STRENGTH =
  "Min Activity Strength";
export const RESERVE_ACTIVITIES_FIELD_MAX_ACTIVITY_STRENGTH =
  "Max Activity Strength";
export const RESERVE_ACTIVITIES_FIELD_ALLOW_OVERBOOK =
  "Allow Overbook Reservation";
export const RESERVE_ACTIVITIES_FIELD_ALLOW_STANDBY =
  "Allow Standby Reservation";
export const RESERVE_ACTIVITIES_FIELD_AUTO_CONFIRM_STANDBY =
  "Auto confirmation of standby after cancellation";
export const RESERVE_ACTIVITIES_FIELD_MAX_STANDBY_STRENGTH =
  "Max Standby Strength";
export const RESERVE_ACTIVITIES_FIELD_GUEST_TYPE = "Guest Type";
export const RESERVE_ACTIVITIES_FIELD_GUEST_TYPE_PRICING = "Guest Type Pricing";
export const RESERVE_ACTIVITIES_FIELD_MEMBERSHIP_TYPE = "Membership Type";
export const RESERVE_ACTIVITIES_FIELD_MEMBERSHIP_PRICING = "Membership Pricing";
export const RESERVE_ACTIVITIES_FIELD_START_DATE = "Start Date";
export const RESERVE_ACTIVITIES_FIELD_END_DATE = "End Date";
export const RESERVE_ACTIVITIES_FIELD_DAYS_OF_WEEK = "Days of the week";
/** @deprecated Legacy combined window; use Start Time and End Time. */
export const RESERVE_ACTIVITIES_FIELD_START_END_TIME = "Start Time/End Time";
export const RESERVE_ACTIVITIES_FIELD_START_TIME = "Start Time";
export const RESERVE_ACTIVITIES_FIELD_END_TIME = "End Time";
export const RESERVE_ACTIVITIES_FIELD_NUMBER_OF_LOCATIONS =
  "Number of Locations";
export const RESERVE_ACTIVITIES_FIELD_LOCATION_NAME = "Location Name";
export const RESERVE_ACTIVITIES_FIELD_STAFF_GUIDE = "Staff/Guide";
export const RESERVE_ACTIVITIES_FIELD_REQUIRE_PREPAYMENT = "Require prepayment";
export const RESERVE_ACTIVITIES_FIELD_PAYMENT_TYPE = "Payment Type";
export const RESERVE_ACTIVITIES_FIELD_BASE_PRICE = "Base Price";
export const RESERVE_ACTIVITIES_FIELD_CANCELLATION_FEE_REQUIRED =
  "Cancellation Fee Required";
export const RESERVE_ACTIVITIES_FIELD_CANCELLATION_FEE_TYPE =
  "Cancellation Fee Type";
export const RESERVE_ACTIVITIES_FIELD_CANCELLATION_DEADLINE =
  "Cancellation deadline";
export const RESERVE_ACTIVITIES_FIELD_CANCELLATION_POLICY_DESCRIPTION =
  "Cancellation Policy Description";
export const RESERVE_ACTIVITIES_FIELD_ALLOW_ADDITIONAL_GUEST_DETAILS =
  "Allow Additional Guest Details";
export const RESERVE_ACTIVITIES_FIELD_COLLECT_ADDITIONAL_EMPLOYEE_DETAILS =
  "Collect Additional Employee Details";
export const RESERVE_ACTIVITIES_FIELD_ACTIVITY_IMAGE =
  "Activity Image (1920 - 1080px)";
export const RESERVE_ACTIVITIES_FIELD_RESERVATION_PARAMETER =
  "Reservation Parameter (Age/Height Restriction if any)";
export const RESERVE_ACTIVITIES_FIELD_ADDONS_NAME =
  "Addons Name ( Mandatory/Optional for an activity)";
export const RESERVE_ACTIVITIES_FIELD_AVAILABLE_WEB =
  "Available for web Reservation";
export const RESERVE_ACTIVITIES_FIELD_CHECK_IN_CUTOFF =
  "Check-In Cut off minutes";
